import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import {
  ApplicationStore,
  getModuleGroupByName,
  SOFTLINE_FEATURE_APPLICATIONS,
} from '@softline/application';
import {
  provideSoftAppsModule,
  withLazySoftAppsModuleTranslation,
  withSoftAppsModuleInfo,
  withSoftAppsModuleRoutes,
} from '@softapps/core';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../i18n/de.json';
import { default as deTitles } from '../i18n/de.titles.json';
import { gutscheinkartenRoutes } from './gutscheinkarten.routes';
import { SOFTLINE_PERMISSION_COUPON_CARD } from './coupon-app.shared';

export function provideGutscheinkartenModule() {
  return [
    provideSoftAppsModule(
      {
        name: 'gutscheinkarten',
        title: '#COUPONS.TITLE',
        icon: 'fa-regular fa-credit-card-blank',
        route: '/gutscheinkarten',
        permission: SOFTLINE_PERMISSION_COUPON_CARD,
        group: getModuleGroupByName('Handel'),
      },
      withSoftAppsModuleRoutes({ app: gutscheinkartenRoutes }),
      withLazySoftAppsModuleTranslation({
        eager: { de: deTitles },
        lazy: { de: () => import('../i18n/de.json') },
      }),
      withSoftAppsModuleInfo({
        library: '@softapps/handel/gutscheinkarten',
        description: 'Gutscheinkarten ausgeben und abfragen.',
      })
    ),
  ];
}

export let gutscheinkartenProviders: (Provider | EnvironmentProviders)[];
gutscheinkartenProviders = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'gutscheinkarten',
      language: 'de',
      translations: de,
    });
    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: '#COUPONS.TITLE',
      icon: 'fa-regular fa-credit-card-blank',
      route: '/gutscheinkarten',
      permission: SOFTLINE_PERMISSION_COUPON_CARD,
      group: getModuleGroupByName('Handel'),
    });
  }),
];
